import { render, staticRenderFns } from "./man-and-van.vue?vue&type=template&id=3ed4c836"
import script from "./man-and-van.vue?vue&type=script&lang=js"
export * from "./man-and-van.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ServicesHeader: require('/opt/atlassian/pipelines/agent/build/components/services/ServicesHeader.vue').default,ServicesVanSizes: require('/opt/atlassian/pipelines/agent/build/components/services/VanSizes.vue').default,BusinessReview: require('/opt/atlassian/pipelines/agent/build/components/business/BusinessReview.vue').default,GridWrapper: require('/opt/atlassian/pipelines/agent/build/components/GridWrapper.vue').default,HomePageSection: require('/opt/atlassian/pipelines/agent/build/components/HomePageSection.vue').default})
